import { tw } from '@/utils/tw';
import BaseMorePagesTitleTheme from 'base/components/MorePagesTitle/theme';

const MorePagesTitle = tw.theme({
  extend: BaseMorePagesTitleTheme,
  base: `mx-6 -mb-6 mt-7 flex flex-row items-center gap-3 whitespace-nowrap text-headline-sm before:order-2 before:block before:h-0.25 before:w-full before:bg-black after:order-3 after:h-6 after:w-100 after:bg-[url("/image/elle-logo.svg")] after:bg-center after:bg-no-repeat sm:after:w-40 md:text-headline-md md:after:w-32`,
});

export default MorePagesTitle;
